import React from 'react';
import { motion } from 'framer-motion';
import line from "../../line/line.svg";
import { FaQuoteLeft } from "react-icons/fa";
import b1 from "../../line/b1.png"
import blogbanner from "./banner2.jpg"
import { Helmet } from 'react-helmet';


function Blog2() {

    return (
        <div className='container mx-auto min-h-screen pt-[150px] flex-col justify-center items-center'>
            {/* Helmet for SEO */}
            <Helmet>
                <title>Upcoming Project in Himachal- Chail Heights Villas</title>
                <meta
                    name="description"
                    content="Chail Heights Villas is coming with luxury villas in Chail Himachal. These properties can be your ideal dream home in Himachal Pradesh or home in hills."
                />
            </Helmet>
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8 }}
                className="max-w-6xl mx-auto p-5"
            >
                <img src={blogbanner} className='mb-2 md:mb-8 aspect-video object-contain' alt="apartment in Chail Himachal" />
            </motion.div>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8 }}
                className="text-center flex flex-col items-center justify-center"
            >
                <h1 className="text-3xl md:text-4xl font-bold text-[#ad9b73] font-serif">
                    Upcoming Project in Himachal : Chail Heights Villas
                </h1>
                <img src={line} alt="line" className="w-full h-[50px] opacity-70 ml-[-5px]" />
            </motion.div>
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8 }}
                className="max-w-7xl mx-auto"
            >
                <div className="relative p-8 md:p-12 before:absolute before:inset-0 before:bg-gradient-to-r 
            before:from-transparent before:via-[#ad9b73]/5 before:to-transparent
            before:opacity-0 before:transition-opacity rounded-lg"
                >
                    <div className="relative">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 0.1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                            className="absolute -top-6 -left-4 text-[#ad9b73]"
                        >
                            <FaQuoteLeft className="w-12 h-12" />
                        </motion.div>

                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, margin: "-100px" }}
                            variants={{
                                visible: {
                                    transition: {
                                        staggerChildren: 0.2
                                    }
                                }
                            }}
                            className="space-y-6 text-gray-600 leading-relaxed text-md md:text-lg relative text-justify z-10"
                        >
                            <motion.p
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                Himachal Pradesh has long been admired for its rich cultural heritage, serene mountains, and breathtaking tourist destinations. However, in recent years, most of the popular towns like Shimla, Solan, Kasauli, and Manali have become heavily commercialized, making them less ideal for building a peaceful, personal retreat. The growing crowd, traffic, and urban sprawl have taken away the very charm that once made these places so desirable.
                            </motion.p>
                            <motion.p
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                That’s precisely why we chose Chail as the location for our exclusive project — <b>Chail Heights Villas</b>. Located away from the hustle and bustle, this serene hill station offers a tranquil escape amidst lush green forests and rolling mountains. At an altitude of 7,500 feet above sea level, Chail enjoys a more refreshing and pleasant climate compared to the more crowded towns nearby, making it perfect for a vacation home or a peaceful retirement haven in Chail.
                            </motion.p>
                            <motion.p
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                Surrounded by unspoiled nature and a calming ambiance, Chail is fast emerging as a prime destination for both holiday homes and long-term living in Himachal Pradesh. Our project is strategically positioned in the heart of Chail, where you can truly reconnect with nature, breathe cleaner air, and enjoy uninterrupted mountain views — all while staying connected to essential amenities and comfort. That’s why we can say this is the best project in chail.
                            </motion.p>
                            <motion.div
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                Chail Heights Villas offers the finest property in Chail – and the reason lies in what we bring to the table. Let’s take a closer look at our exclusive offerings:
                                <motion.div
                                    className='flex items-center gap-5 mt-5'
                                    variants={{
                                        hidden: { opacity: 0, y: 20 },
                                        visible: { opacity: 1, y: 0 }
                                    }}
                                    transition={{ duration: 0.6 }}
                                >
                                    <img src={b1} className='h-[25px]' alt="" />
                                    <p>We offer Independent villas in chail which you can use as a vacation home or like a retirement home
                                    </p>
                                </motion.div>
                                <motion.div
                                    className='flex items-center gap-5 mt-5'
                                    variants={{
                                        hidden: { opacity: 0, y: 20 },
                                        visible: { opacity: 1, y: 0 }
                                    }}
                                    transition={{ duration: 0.6 }}
                                >
                                    <img src={b1} className='h-[25px]' alt="" />
                                    <p>In addition to villas, the project also includes well-appointed apartments in Chail, catering to different budgets and lifestyle preferences—making it a perfect choice for families, retirees, or remote workers seeking a peaceful hill station life
                                    </p>
                                </motion.div>
                            </motion.div>

                            <motion.div
                                initial={{ opacity: 0, y: -20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-100px" }}
                                transition={{ duration: 0.8 }}
                                className="text-center my-8 flex flex-col items-center justify-center"
                            >
                                <h2 className="text-3xl md:text-4xl font-bold text-[#ad9b73] font-serif">
                                    Why Chail Heights Villas?
                                </h2>
                                <img src={line} alt="line" className="w-full h-[50px] opacity-70 ml-[-5px]" />
                            </motion.div>
                            <motion.p
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                Chail Heights Villas isn’t just another real estate project in Himachal—it’s a thoughtfully designed private gated township that blends nature, luxury, and modern comfort. Here’s what makes it special:
                            </motion.p>
                            <motion.div
                                className='flex items-center gap-5'
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                <img src={b1} className='h-[25px]' alt="" />
                                <p>Exclusive Villas in Himachal Pradesh with panoramic mountain views                                </p>
                            </motion.div>
                            <motion.div
                                className='flex items-center gap-5'
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                <img src={b1} className='h-[25px]' alt="" />
                                <p>A secure, gated community in chail ensuring privacy and peace of mind                                </p>
                            </motion.div>
                            <motion.div
                                className='flex items-center gap-5'
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                <img src={b1} className='h-[25px]' alt="" />
                                <p>All basic amenities and necessities within the township – roads, water supply, power backup, security, and more
                                </p>
                            </motion.div>
                            <motion.div
                                className='flex items-center gap-5'
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                <img src={b1} className='h-[25px]' alt="" />
                                <p>High rental potential as a vacation home investment
                                </p>
                            </motion.div>
                            <motion.div
                                className='flex items-center gap-5'
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                <img src={b1} className='h-[25px]' alt="" />
                                <p>Located near Shimla, yet far from the tourist rush
                                </p>
                            </motion.div>
                            <motion.p
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 }
                                }}
                                transition={{ duration: 0.6 }}
                            >
                                If you’re exploring an upcoming project in Himachal that combines charm, comfort, and value, look no further than Chail Heights Villas. It’s more than just a home—it’s a mountain retreat, a sound investment, and a legacy for future generations.
                            </motion.p>
                        </motion.div>
                    </div>
                </div>
            </motion.div>
        </div>
    )
}

export default Blog2